module.exports = __webpack_public_path__ + "res/img_game_bg.399e394f3a35a361d9ae72e0eebfc7f3.png";